import {Component, WritableSignal} from '@angular/core';
import {style} from "@angular/animations";
import {ToastService} from "src/app/services/Toast/toast.service";
import {TitleCasePipe} from "@angular/common";
import {SpinnerComponent} from "src/app/common/spinner/spinner.component";

@Component({
    selector: 'toast',
    imports: [
        TitleCasePipe,
        SpinnerComponent
    ],
    templateUrl: './toast.component.html',
    styleUrl: './toast.component.scss'
})
export class ToastComponent {
  items!: WritableSignal<ToastItem[]>;
  constructor(public toast: ToastService) {
    this.items = toast.getItems();
  }

  protected readonly style = style;
}
export interface ToastItem {
  style: 'success'|'warning'|'error'|'info'|'loading',
  type: 'static'|'timed',
  message: string,
  time: number,
  elapsed: number
}
